import { IconArrowRight } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { ProgressiveDiscountEffect } from '../../../../typings'
import { messages } from '../messages'
import styles from './styles'
import { useNumbers } from 'ui/components/utils/useNumbers'

type Props = {
  discount: ProgressiveDiscountEffect
}

const renderTag = (content) => <Tag>{content}</Tag>

export function ProgressiveDiscountRow(props: Props) {
  const {
    discount: { benefit, trigger },
  } = props
  const { $t } = useIntl()
  const { formatPercentual } = useNumbers()

  if (!trigger || !benefit) return null

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.discount.title} />
      </SummaryRow.Title>
      <SummaryRow.Value className={styles.valueContentColumn}>
        <span>
          {$t(messages.progressive.description, {
            tag: renderTag,
          })}
        </span>
        {benefit.map(({ quantity, discount }, index) => (
          <span key={index} className={styles.progressiveDiscountContainer}>
            {$t(messages.progressive.itemValue, {
              quantity: quantity,
              discount: formatPercentual(discount),
              tag: renderTag,
              arrowRightIcon: (
                <IconArrowRight size="small" className={styles.arrow} />
              ),
            })}
          </span>
        ))}
        {trigger.sameItemsOnly && (
          <Tag>{$t(messages.progressive.sameItemsOnly)}</Tag>
        )}
      </SummaryRow.Value>
    </SummaryRow>
  )
}
